<template>
    <div class="hdp-uf-hfs">
         <iframe :src="iframeSrc" style="display: none"></iframe>
        <el-button type="primary" icon="el-icon-download" @click="downloadTemplate()"> {{btnName}} </el-button>
    </div>
</template>
<script>
export default {
    props:['downloadKey', 'btnName'],
    data() {
        return {
            iframeSrc: ""
        }
    },
    methods:{
        downloadTemplate() {
            this.iframeSrc = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
             + "/report/getReportTemplate"
             + "?key=" + this.downloadKey
             + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
             + '&accept-language='+sessionStorage.getItem('defaultLang')
             + '&t=' + Date.now() 
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LapDownloadBtn.vue